import { Button } from '@datacamp/waffles/button';
import React, { useCallback } from 'react';
import { useTranslation } from '../useTranslation';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Reconnector = _ref => {
  let {
    debugMessage,
    restartSession,
    statusMessage
  } = _ref;
  const {
    t
  } = useTranslation();
  const getCustomFeedback = useCallback(() => {
    switch (statusMessage) {
      case 'websocket-error':
        return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("h3", null, t('Reconnector.websocketErrorTitle')), ___EmotionJSX("p", null, t('Reconnector.websocketErrorText')), ___EmotionJSX("ul", null, ___EmotionJSX("li", null, t('Reconnector.websocketErrorItemOne')), ___EmotionJSX("li", null, t('Reconnector.websocketErrorItemTwo')), ___EmotionJSX("li", null, t('Reconnector.websocketErrorItemThree')), ___EmotionJSX("li", null, t('Reconnector.websocketErrorItemFour'))));
      case 'websocket-duplicate-error':
        return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("h3", null, t('Reconnector.websocketDuplicateErrorTitle')), ___EmotionJSX("p", null, t('Reconnector.defaultErrorText')));
      case 'session-error':
      default:
        return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("h3", null, t('Reconnector.defaultErrorTitle')), ___EmotionJSX("p", null, t('Reconnector.defaultErrorText')));
    }
  }, [statusMessage, t]);
  return ___EmotionJSX("div", {
    className: "dc-u-fx dc-u-fx-fww dc-u-fx-aic dc-u-bgc-grey-100 dc-u-fx-jcc dc-u-wh-100pc dc-u-ta-center dc-u-of-scroll dc-u-p-24"
  }, ___EmotionJSX("div", null, ___EmotionJSX("div", null, getCustomFeedback()), ___EmotionJSX(Button, {
    "data-cy": 'restart-session-button',
    onClick: restartSession,
    size: "small",
    type: "button",
    variant: "primary"
  }, t('Reconnector.button'))), debugMessage !== undefined && ___EmotionJSX("div", null, ___EmotionJSX("h4", null, t('Reconnector.debugMessageTitle')), ___EmotionJSX("p", {
    className: "dc-u-color-red dc-u-ta-left dc-u-ws-pre-wrap",
    style: {
      wordBreak: 'break-word'
    }
  }, debugMessage)));
};
export default Reconnector;